import { Outlet, useOutletContext } from 'react-router-dom';

function BountySubmissions() {
    const state = useOutletContext();

    return (
        <div>
            <Outlet context={{ backHandler: state[2] }} />
        </div>
    );
}

export default BountySubmissions;
